import { Component, OnInit } from '@angular/core';
import { SAMSessionService } from 'src/app/sam/sam-session.service';
import { BasePaymentPage } from 'src/app/base/payment-page';
import { NavController, ModalController, NavParams } from '@ionic/angular';
import { SAMService } from 'src/app/sam/sam.service';
import { ConfigService } from 'src/app/config.service';
import { GUIService } from '../../gui.service';
import { ThemeService } from 'ngx-elvis-ds';
import { CartService } from 'src/app/services/cart.service';
import { I18NService } from 'src/app/services/i18n.service';
import { WindowRef } from '../../../window-ref.service';

@Component({
  selector: 'app-payment-dialog',
  templateUrl: './payment-dialog.page.html',
  styleUrls: ['./payment-dialog.page.scss'],
})
export class PaymentDialogPage extends BasePaymentPage {

  useKeyboard: boolean = true;

  constructor(
    public samSessionSvc: SAMSessionService,
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    public sam: SAMService,
    public configSvc: ConfigService,
    public guiSvc: GUIService,
    public themeSvc: ThemeService,
    public cartSvc: CartService,
    public i18nSvc: I18NService,
    public winRef: WindowRef
  ) {
    super(navCtrl, modalCtrl, navParams, sam, configSvc, guiSvc, cartSvc, winRef);
  }

  ionViewDidEnter() {
  }

  // never implement lifecycle hooks as they are already implemented on BasePaymentPage

  setTenderColor(tender: any) {
    if (tender.IsGlory) {
      return 'success';
    } else {
      return 'tertiary';
    }
  }

}
